.page {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
  width: 100%;
  max-width: calc(var(--content-max) + 2 * var(--page-gutter));
  margin: 0 auto;
  padding: calc(var(--space-10) + var(--safe-top)) var(--page-gutter);
}

.block {
  height: 240px;
}
